import React from "react";
import ModalOrSheet from "../ui/ModalOrSheet.jsx";

export default function SimpleModal({ open, onClose, title, children, maxWidth = 600 }) {
  return (
    <ModalOrSheet
      open={open}
      onClose={onClose}
      title={title}
      maxWidth={typeof maxWidth === "number" ? maxWidth : "md"}
      closeOnOverlay
      escCloses
    >
      {children}
    </ModalOrSheet>
  );
}
